// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AK82","buttons":"styles_buttons__1VDXl"};